import { apiRequestAsync } from "../../functions/FetchWithToast";
import { SEARCH, CATEGORY } from "../Api";

export const headerBarSearch = (term) => apiRequestAsync({
    request_details: SEARCH('variant', 'name', term, 5),
});

export const categorySearch = (term) => apiRequestAsync({
    request_details: CATEGORY(term),
});